import styled from 'styled-components';

export const StyledLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 0;
    overflow: hidden;
    color: ${({ theme }) => theme.color.white};
    background-color: ${({ theme }) => theme.color.purple};
    transform: translateY(-100%);

    &:focus {
        height: 4.4rem;
        overflow: visible;
        outline: none;
        transform: translateY(0);
    }
`;
